/**
 * Desktop Header Localization - Click Toggle
 * Handles showing/hiding the language dropdown on click for desktop
 */

class HeaderLocalization extends HTMLElement {
  constructor() {
    super();
    this.wrapper = this.querySelector('.header-localization-dropdown-wrapper');
    this.button = this.querySelector('#headerLocalizationDropdown');
    this.menu = this.querySelector('.header-localization-menu');
    
    if (this.button && this.wrapper) {
      this.init();
    }
  }

  init() {
    // Toggle dropdown on button click
    this.button.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      this.toggleDropdown();
    });

    // Close dropdown when clicking outside
    document.addEventListener('click', (e) => {
      if (!this.contains(e.target)) {
        this.closeDropdown();
      }
    });

    // Close dropdown when pressing Escape
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.wrapper.classList.contains('active')) {
        this.closeDropdown();
        this.button.focus();
      }
    });
  }

  toggleDropdown() {
    const isActive = this.wrapper.classList.contains('active');
    
    if (isActive) {
      this.closeDropdown();
    } else {
      this.openDropdown();
    }
  }

  openDropdown() {
    this.wrapper.classList.add('active');
    this.button.setAttribute('aria-expanded', 'true');
  }

  closeDropdown() {
    this.wrapper.classList.remove('active');
    this.button.setAttribute('aria-expanded', 'false');
  }
}

customElements.define('header-localization', HeaderLocalization);

